import { C11nEnv } from '../../interpreter/c11n-env';
import type { AIAgentCoachModel, UnresolvedGenAICoach } from '../../rules/types';
import AnnotationsHandler from '..';
import * as RuleStore from '../../rules/rules-store';

type DestinationObject = {
  label: string;
};

AnnotationsHandler.registerHandler('@AIAGENT', (AIAgentName: string, c11nEnv: C11nEnv): AIAgentCoachModel | null => {
  const resolvedAgent = RuleStore.getAIAgent(AIAgentName, c11nEnv.getCurrentClassID());
  if (resolvedAgent) {
    return resolvedAgent;
  }

  // The following code is used for resolving the underlying AIAgent entry in Launchpad
  const componentConfig = c11nEnv.getComponentConfig();
  if (componentConfig) {
    // Given that the component config is the outer widget, we need to find the matching coach instance in the list
    const matchingUnresolvedConfigObj = componentConfig?.coaches?.find(
      (coachObj: UnresolvedGenAICoach) =>
        coachObj?.config?.coach?.substring('@AIAGENT '.length) === AIAgentName && coachObj?.config?.ruleNamespace
    )?.config;

    if (matchingUnresolvedConfigObj?.label) {
      const destinationObject: DestinationObject = { label: matchingUnresolvedConfigObj.label };
      c11nEnv.resolveConfigProps({ label: matchingUnresolvedConfigObj.label }, destinationObject);
      const resolvedLabel = destinationObject.label;

      return {
        insName: `${matchingUnresolvedConfigObj.ruleNamespace}__${AIAgentName}`,
        label: c11nEnv.getLocalizedValue(resolvedLabel),
        type: 'agent'
      };
    }
  }
  return null;
});
